import { useState } from 'react';
import { setValmislauseTagReportTypes } from '../api/api';

// Single dropdown report-type picker for one valmislause tag — the trigger
// itself shows the current selection ("Yleinen: kaikki raporttityypit",
// one name, or "N valittu"), opening a checklist panel to toggle membership
// directly. Replaces an earlier chip-row + separate "+ Lisää…" select —
// kept as two visually mismatched controls bolted together; the user asked
// for the dropdown to just show what's enabled instead.
//
// `tag` needs { id, report_types }. `allReportTypes` is [{ type, name }],
// fetched once by the caller (getLlmReportTypes — shared with the LLM-prompt
// feature rather than duplicated here) and passed down so every tag's picker
// doesn't re-fetch it. `onChange(newTypes)` is called after a successful
// save so the caller can patch its own tags state/cache.
export default function TagReportTypesPicker({ tag, allReportTypes, onChange }) {
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const current = tag.report_types || [];

  const save = async (newTypes) => {
    setBusy(true);
    try {
      await setValmislauseTagReportTypes(tag.id, newTypes);
      onChange?.(newTypes);
    } finally {
      setBusy(false);
    }
  };

  const toggle = (type) => {
    save(current.includes(type) ? current.filter(x => x !== type) : [...current, type]);
  };

  const triggerLabel = current.length === 0
    ? 'Yleinen: kaikki raporttityypit'
    : current.length === 1
      ? (allReportTypes.find(r => r.type === current[0])?.name || current[0])
      : `${current.length} raporttityyppiä valittu`;

  return (
    <div className="d-flex align-items-center gap-2" style={{ fontSize: '0.8rem', position: 'relative' }}>
      <span className="text-muted">Raporttityypit:</span>
      <button type="button" onClick={() => setOpen(o => !o)} disabled={busy}
        className="d-flex align-items-center gap-2"
        aria-expanded={open}
        style={{
          fontSize: '0.8rem', padding: '4px 10px', borderRadius: 999, border: '1px solid #dee2e6',
          background: '#fff', color: current.length ? '#3e4c59' : '#6c757d', cursor: 'pointer',
        }}>
        {triggerLabel}
        <i className="bi bi-chevron-down" style={{ fontSize: '0.65rem', color: '#adb5bd' }} />
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 20 }} />
          <div style={{
            position: 'absolute', top: '100%', left: 0, marginTop: 4, width: 240, maxHeight: 280, overflowY: 'auto',
            background: '#fff', border: '1px solid #e4e6e8', borderRadius: 10, boxShadow: '0 8px 24px rgba(20,20,22,0.12)',
            padding: 6, zIndex: 21,
          }}>
            {allReportTypes.map(r => (
              <label key={r.type} className="d-flex align-items-center gap-2"
                style={{ padding: '6px 8px', fontSize: '0.82rem', borderRadius: 6, cursor: busy ? 'default' : 'pointer' }}>
                <input type="checkbox" checked={current.includes(r.type)} disabled={busy} onChange={() => toggle(r.type)} />
                {r.name}
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
